import {HttpContext} from "@angular/common/http";
import {USE_ACTIVE_LOCATION} from "./context";

export function withActiveLocation() {
  return {
    context: new HttpContext().set(USE_ACTIVE_LOCATION, true)
  };
}
